import api from "../api/flexapi";

// Type of action being performed
export const SHOP_ACTIVITY_DETAILS_LOAD_REQUEST = "SHOP_ACTIVITY_DETAILS_LOAD_REQUEST";
export const SHOP_ACTIVITY_DETAILS_LOAD_SUCCESS = "SHOP_ACTIVITY_DETAILS_LOAD_SUCCESS";
export const SHOP_ACTIVITY_DETAILS_LOAD_FAILURE = "SHOP_ACTIVITY_DETAILS_LOAD_FAILURE";

// Call API to load module data
export function loadShopActivityDetails(activityId) {
  // Return thunk middleware
  return dispatch => {
    dispatch({
      type: SHOP_ACTIVITY_DETAILS_LOAD_REQUEST,
      payload: { activityId },
    });

    api
      .getShopActivityDetails(activityId)
      .then(response => {
        dispatch({
          type: SHOP_ACTIVITY_DETAILS_LOAD_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: SHOP_ACTIVITY_DETAILS_LOAD_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export const SHOP_ACTIVITIES_LOAD_REQUEST = "SHOP_ACTIVITIES_LOAD_REQUEST";
export const SHOP_ACTIVITIES_LOAD_SUCCESS = "SHOP_ACTIVITIES_LOAD_SUCCESS";
export const SHOP_ACTIVITIES_LOAD_FAILURE = "SHOP_ACTIVITIES_LOAD_FAILURE";

export function loadShopActivities(pageToLoad, keyword, includeSignUps) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: SHOP_ACTIVITIES_LOAD_REQUEST, payload: null });

    const searchKeyword = keyword ? keyword : "";

    api
      .getShopActivities(pageToLoad, searchKeyword, includeSignUps)
      .then(response => {
        dispatch({
          type: SHOP_ACTIVITIES_LOAD_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: SHOP_ACTIVITIES_LOAD_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export const SIGNEDUP_ACTIVITIES_LOAD_REQUEST = "SIGNEDUP_ACTIVITIES_LOAD_REQUEST";
export const SIGNEDUP_ACTIVITIES_LOAD_SUCCESS = "SIGNEDUP_ACTIVITIES_LOAD_SUCCESS";
export const SIGNEDUP_ACTIVITIES_LOAD_FAILURE = "SIGNEDUP_ACTIVITIES_LOAD_FAILURE";

export function loadSignedUpActivities() {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: SIGNEDUP_ACTIVITIES_LOAD_REQUEST, payload: null });

    api
      .getSignedUpActivities()
      .then(response => {
        dispatch({
          type: SIGNEDUP_ACTIVITIES_LOAD_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: SIGNEDUP_ACTIVITIES_LOAD_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export const MY_ACTIVITIES_ADD_REQUEST = "MY_ACTIVITIES_ADD_REQUEST";
export const MY_ACTIVITIES_ADD_SUCCESS = "MY_ACTIVITIES_ADD_SUCCESS";
export const MY_ACTIVITIES_ADD_FAILURE = "MY_ACTIVITIES_ADD_FAILURE";

export const MY_ACTIVITIES_REMOVE_REQUEST = "MY_ACTIVITIES_REMOVE_REQUEST";
export const MY_ACTIVITIES_REMOVE_SUCCESS = "MY_ACTIVITIES_REMOVE_SUCCESS";
export const MY_ACTIVITIES_REMOVE_FAILURE = "MY_ACTIVITIES_REMOVE_FAILURE";

export const MY_ACTIVITIES_RESEND_REQUEST = "MY_ACTIVITIES_RESEND_REQUEST";
export const MY_ACTIVITIES_RESEND_SUCCESS = "MY_ACTIVITIES_RESEND_SUCCESS";
export const MY_ACTIVITIES_RESEND_FAILURE = "MY_ACTIVITIES_RESEND_FAILURE";

export const MY_ACTIVITIES_RESET_RELOAD = "MY_ACTIVITIES_RESET_RELOAD";

export function resetReload() {
  return dispatch => dispatch({ type: MY_ACTIVITIES_RESET_RELOAD, payload: null });
}

export function addActivity(activity) {
  return dispatch => {
    dispatch({ type: MY_ACTIVITIES_ADD_REQUEST, payload: activity });

    api
      .signupForActivity(activity)
      .then(response => {
        dispatch({ type: MY_ACTIVITIES_ADD_SUCCESS, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: MY_ACTIVITIES_ADD_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export function removeActivity(activity, code) {
  return dispatch => {
    dispatch({ type: MY_ACTIVITIES_REMOVE_REQUEST, payload: activity });

    api
      .cancelActivitySignup({ signUpCode: code })
      .then(response => {
        dispatch({
          type: MY_ACTIVITIES_REMOVE_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: MY_ACTIVITIES_REMOVE_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export function resendActivityDetails(activity, code) {
  return dispatch => {
    dispatch({ type: MY_ACTIVITIES_RESEND_REQUEST, payload: activity });

    api
      .resendActivityDetails({ signUpCode: code })
      .then(response => {
        dispatch({
          type: MY_ACTIVITIES_RESEND_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: MY_ACTIVITIES_RESEND_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/shopActivitiesActions.jsx